export function DtoResRegistrarBranding() {
    return {
        codigo: '',
        data: '',
        dataExtra: null,
        mensaje: '',
        mensajeExtra: ''
    }
};